import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { STPUnitTypeDDL } from '../../../../../../Components/CommonDDL/STPStatusDDL';
import { STPMachineryChecklistPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveWorkMachineryChecklistSlice';

export default function STPMachineryChecklistDataPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [Status, setStatus] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [MachineryChecklistTextField, setMachineryChecklistTextField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        machEquipmentType: Flag === 'Update' ? rowData.machEquipmentType : '',
        machineryDetails: Flag === 'Update' ? rowData.machineryDetails : '',
    })

    const handleMachineryChecklistTextField = (e) => {
        setMachineryChecklistTextField({ ...MachineryChecklistTextField, [e.target.name]: e.target.value })
    }


    const handlePost = () => {
        const data = {
            T_STP_MachineryCheckListID: Flag === 'Update' ? rowData.t_stP_MachineryCheckListID : '0',
            M_STP_MachineryActionsID: Status.ID,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPMachineryChecklistPostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Machinery Checklist</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Reading Date</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="readingDate"
                                            name='readingDate'
                                            value={MachineryChecklistTextField.readingDate}
                                            onChange={(e) => handleMachineryChecklistTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Mach Equipment Type</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="machEquipmentType"
                                            name='machEquipmentType'
                                            value={MachineryChecklistTextField.machEquipmentType}
                                            onChange={(e) => handleMachineryChecklistTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Machinery Details</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="machineryDetails"
                                            name='machineryDetails'
                                            value={MachineryChecklistTextField.machineryDetails}
                                            onChange={(e) => handleMachineryChecklistTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <STPUnitTypeDDL
                                        Status={Status}
                                        setStatus={setStatus}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            MachineryChecklistTextField.readingDate == '' || MachineryChecklistTextField.machEquipmentType == '' ||
                                            MachineryChecklistTextField.machineryDetails == '' || Status.ID == 0
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}